import React from 'react'

export const ChatMediaFocusIcon = ({
  size = 30,
  className,
  opacity = 1,
}: {
  color?: string
  size?: number
  className?: string
  opacity?: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      className={className}
      fill="none"
      opacity={opacity}
    >
      <g>
        <path
          d="M18 7.5C20.2091 7.5 22 9.29086 22 11.5V18.5C22 20.7091 20.2091 22.5 18 22.5H12L11.7939 22.4951C9.7488 22.3913 8.10865 20.7512 8.00488 18.7061L8 18.5V11.5C8 9.29086 9.79086 7.5 12 7.5H18ZM12 9C10.6193 9 9.5 10.1193 9.5 11.5V18.5C9.5 19.8807 10.6193 21 12 21H18C19.3807 21 20.5 19.8807 20.5 18.5V11.5C20.5 10.1193 19.3807 9 18 9H12ZM12.5 15.5C13.6046 15.5 14.5 16.3954 14.5 17.5C14.5 18.6046 13.6046 19.5 12.5 19.5C11.3954 19.5 10.5 18.6046 10.5 17.5C10.5 16.3954 11.3954 15.5 12.5 15.5ZM18.5 16.75C18.9142 16.75 19.25 17.0858 19.25 17.5C19.25 17.9142 18.9142 18.25 18.5 18.25H16C15.5858 18.25 15.25 17.9142 15.25 17.5C15.25 17.0858 15.5858 16.75 16 16.75H18.5ZM12.5 17C12.2239 17 12 17.2239 12 17.5C12 17.7761 12.2239 18 12.5 18C12.7761 18 13 17.7761 13 17.5C13 17.2239 12.7761 17 12.5 17ZM12.5 10.5C13.6046 10.5 14.5 11.3954 14.5 12.5C14.5 13.6046 13.6046 14.5 12.5 14.5C11.3954 14.5 10.5 13.6046 10.5 12.5C10.5 11.3954 11.3954 10.5 12.5 10.5ZM18.5 11.75C18.9142 11.75 19.25 12.0858 19.25 12.5C19.25 12.9142 18.9142 13.25 18.5 13.25H16C15.5858 13.25 15.25 12.9142 15.25 12.5C15.25 12.0858 15.5858 11.75 16 11.75H18.5ZM12.5 12C12.2239 12 12 12.2239 12 12.5C12 12.7761 12.2239 13 12.5 13C12.7761 13 13 12.7761 13 12.5C13 12.2239 12.7761 12 12.5 12Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default ChatMediaFocusIcon
